module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/boxoffice-module/components/basket-detail/basket-detail.component.scss
// module id = ./src/app/modules/boxoffice-module/components/basket-detail/basket-detail.component.scss
// module chunks = 9